import { httpV2 } from "@/api";

/**
 * @summary Solicita todos os fabricantes de gearbox.
 * @returns Conjunto de fabricante.
 */
const GetManufacturers = function()
{
	return httpV2.get("KnowledgeBase/GearboxManufacturers");
};

/**
 * @summary Solicita os modelos de gearbox de um fabricante.
 * @param {number} gearboxManufacturerId Id do fabricante.
 * @returns Conjunto de modelos de gearbox do fabricante.
 */
const GetModels = function(gearboxManufacturerId)
{
	return httpV2.get(`KnowledgeBase/GearboxManufacturers/${gearboxManufacturerId}/Models`);
};

/**
 * @summary Solicita as propriedades de um modelo de gearbox.
 * @param {number} gearboxModelId Id do modelo de gearbox.
 * @returns Propriedades de um modelo de gearbox.
 */
const GetProperties = async function(gearboxModelId)
{
	return httpV2.get(`KnowledgeBase/GearboxModels/${gearboxModelId}/Property`);
};

/**
 * @summary Solicita as configurações de estágios de um modelo de gearbox.
 * @param {number} gearboxModelId Id do modelo de gearbox.
 * @returns Configurações de um estágios de um modelo de gearbox.
 */
const GetStages = async function(gearboxModelId)
{
	return httpV2.get(`KnowledgeBase/GearboxModels/${gearboxModelId}/Stages`);
};

export default {
	GetManufacturers,
	GetModels,
	GetProperties,
	GetStages
};